import { ROT_SET_ROTAS_MENUS_SUCCESS, ROT_SET_ROTAS_MENUS_FAIL } from './types';
import sentinela from '../api/sentinela';
import RouteComponents from '../router/RouteComponents';
import { sendErroRequest } from '../utils/Notification';

const ROTAS_DEFAULT = [
  {
    path: '/acesso-nao-autorizado',
    component: RouteComponents['/acesso-nao-autorizado'],
    permitido: true,
    exact: true,
  },
  {
    path: '/configuracoes',
    component: RouteComponents['/configuracoes'],
    exact: true,
    permitido: true,
  },
  {
    path: '/documentos-bloqueados',
    component: RouteComponents['/documentos-bloqueados'],
    exact: true,
    permitido: true,
  },
];

export const setRotasPermitidasSuccess = rotas => ({
  type: ROT_SET_ROTAS_MENUS_SUCCESS,
  payload: rotas,
});

export const setRotasPermitidasFail = () => ({
  type: ROT_SET_ROTAS_MENUS_FAIL,
});

export const getRotasPermitidas = () => async dispatch => {
  try {
    const { data } = await sentinela.get('/rotas/rotas-permitidas/16');

    const listaRotas = data.rotas.map(rota => ({
      path: rota.path,
      component: RouteComponents[rota.path],
      permitido: rota.permitido,
      exact: true,
    }));

    const rotaIndex = [
      {
        path: '/',
        component: RouteComponents['/dashboards'],
        permitido: true,
        exact: true,
      },
    ];

    dispatch(
      setRotasPermitidasSuccess({
        rotas: [...ROTAS_DEFAULT, ...listaRotas, ...rotaIndex],
        menus: data.menus,
      }),
    );
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar as Rotas Permitidas');

    dispatch(setRotasPermitidasFail());
  }
};
